import Lottie from "lottie-react";
import emptyCartSrc from "../../../public/assets/animations/empty-cart.json";
const EmptyCart = ({ width = 180, height = 309.722, className }) => {
  return (
    <Lottie animationData={emptyCartSrc} loop={true} className="w-60 h-60" />
  );
};

export default EmptyCart;
